import { useState } from "react";
import useBoolean from "@hooks/useBoolean";
export var useConfirmation = function useConfirmation(initialConfirm) {
  var confirmation = useBoolean(initialConfirm || false);
  var _useState = useState(null),
    confirmationHandlers = _useState[0],
    setConfirmationHandlers = _useState[1];
  var awaitConfirmation = function awaitConfirmation() {
    return new Promise(function (resolve) {
      confirmation.setTrue();
      setConfirmationHandlers({
        handleConfirm: function handleConfirm() {
          confirmation.setFalse();
          resolve(true);
        },
        handleCancel: function handleCancel() {
          confirmation.setFalse();
          resolve(false);
        }
      });
    });
  };
  return {
    confirmation: confirmation,
    confirmationHandlers: confirmationHandlers,
    awaitConfirmation: awaitConfirmation
  };
};